import { SpinnerSize, ISpinnerProps, Spinner } from '@fluentui/react/lib/Spinner';

export interface IPSpinnerProps extends ISpinnerProps {}
export { SpinnerSize as IPSpinnerSize };

export const IPSpinner = (props: IPSpinnerProps) => {
  return <Spinner {...props} />;
};
